<template>
  <div class="container mb-4">
    <InvoiceDMT />
    <InvoiceRules />
  </div>
</template>

<script>

import InvoiceDMT from './InvoiceDMT'
import InvoiceRules from './InvoiceRules'

export default {
  name: 'InvoiceSettings',
  components: {
    InvoiceDMT,
    InvoiceRules
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceSettings.vue